import http from 'utilities/httpService';

export class UserTypeService {
  static async getUserTypes() {
    return http.get(`/admin/user-types`);
  }
}
